import {createConsumer} from '@rails/actioncable'

const ActionCablePlugin = {
  install(Vue) {
    // WS_HOST se obtiene del store (runtimeConfig) que lee de window.process.env en runtime
    const wsHost = Vue.store.getters['runtimeConfig/wsHost']
    Vue.cable = createConsumer(wsHost)
    Vue.prototype.$cable = createConsumer(wsHost)
  }
}

Vue.use(ActionCablePlugin)
